import { OnInit, Component, Output, EventEmitter } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { AdmissionWizardService } from "../../../services/wizard/admission/admission.wizzard.service";
import { WizardStep } from "../../../wizard/wizard.component";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { BehaviorSubject } from "rxjs";
import { AdmissionValorization } from "../../../model/admission";
import { ValidateValorizationEdit } from "../../../validators/valorization-edit.validator";

@Component({
  selector: "app-admission-valorization-component",
  templateUrl: "./admission-valorization.component.html",
  styleUrls: ["./admission-valorization.component.css"],
})
export class AdmissionValorizationComponent implements OnInit, WizardStep {
  sectorName: string;
  isOrderInSector: boolean;
  existsCurrentInvoice: boolean;
  isInit: boolean;
  formGroup: FormGroup;
  loadingInit: boolean;
  loading: boolean;
  isRegistered: boolean;
  editableAgreementPriceIds: number[] = [];

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onRecalculate = new EventEmitter();

  constructor(
    private admissionWizardService: AdmissionWizardService,
    private notificationToastService: NotificationToastService,
    private formBuilder: FormBuilder
  ) {
    this.formGroup = this.formBuilder.group({
      ValorizationEdit: [null, [Validators.required, ValidateValorizationEdit]],
    });

    this.formGroup.valueChanges.subscribe(() => {
      this.admissionWizardService.setAdmissionValorization(
        <AdmissionValorization>this.formGroup.getRawValue()
      );
    });
  }

    get valid(): boolean {
    return this.completed;
  }

  get isReadOnly(): boolean {
    return this.admissionWizardService.isReadOnly();
  }

  get isWizzard(): boolean {
    return this.admissionWizardService.isWizzard();
  }
  get f() {
    return this.formGroup.controls;
  }
  get completed(): boolean {
    return !this.formGroup.invalid;
  }

  save() {}

  async activate() {
    if (!this.isWizzard) {
      await this.loadInfo();
    }

    await this.setValorizationValidation();
  }


  async refreshPractice(value) {
    await this.setValorizationValidation();
}

  async addPracticeClick(value) {
      await this.setValorizationValidation();
  }

  private async setValorizationValidation() {
    try {
      let admissionValorization = <AdmissionValorization>(
        this.formGroup.getRawValue()
      );

      const agreementPriceIds =
        admissionValorization.ValorizationEdit.ValorizationAmount.ValorizationItemsAmount.filter(
          (v) => v.ValorizationItem.AgreementPriceId
        ).map((v) => v.ValorizationItem.AgreementPriceId);

      const valorizationValidation =
        await this.admissionWizardService.getValorizacionValidation(
          agreementPriceIds
        );
      this.isRegistered = valorizationValidation.RegisteredProcedures;
      this.editableAgreementPriceIds =
        valorizationValidation.EditableAgreementPriceIds;
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    }
  }

  async ngOnInit() {
    this.isInit = true;
    if (this.isWizzard) {
      await this.loadInfo();
    }
  }

  private async loadInfo() {
    this.loadingInit = true;
    try {
      if (this.isInit) {

        const admissionValorization =
          await this.admissionWizardService.getAdmissionValorization();

        this.formGroup.patchValue({
          ValorizationEdit: admissionValorization.ValorizationEdit,
        });

        this.isOrderInSector = this.admissionWizardService.isOrderInSector();

        if (!this.isOrderInSector) {
          this.formGroup.get("ValorizationEdit").disable();
          this.sectorName = await this.admissionWizardService.getOrderSector();
        } else {
          this.existsCurrentInvoice =
            await this.admissionWizardService.existsCurrentInvoice();
          if (this.existsCurrentInvoice) {
            this.formGroup.get("ValorizationEdit").disable();
          }
        }
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    } finally {
      this.loadingInit = false;
    }
  }

  async recalculate() {
    try {
      this.loading = true;
      let admissionValorization = <AdmissionValorization>(
        this.formGroup.getRawValue()
      );
      admissionValorization =
        await this.admissionWizardService.recalculateAdmissionValorization(
          admissionValorization
        );
      this.formGroup.patchValue({
        ValorizationEdit: admissionValorization.ValorizationEdit,
      });
      this.onRecalculate.emit();
      await this.setValorizationValidation();
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    } finally {
      this.loading = false;
    }
  }
}
